import type { CenterProps } from '@chakra-ui/react';
import { Center } from '@chakra-ui/react';
import { MessageImgIcon, Tooltip } from '@halo/ui-chat-react';
import { useTranslation } from 'react-i18next';

function ImageUploader(props: CenterProps) {
  const { t } = useTranslation();
  return (
    <Tooltip
      content={t('chat.tooltipImage')}
      chakraPortal={false}
      openDelay={0}
      closeDelay={0}
      showArrow={true}
    >
      <Center
        h="1.857em"
        w="1.857em"
        cursor="pointer"
        borderRadius="sm"
        _hover={{ bg: 'bg.muted', color: 'brand.100' }}
        transition="all 0.2s"
        {...props}
      >
        <Center className="shake">
          <MessageImgIcon />
        </Center>
      </Center>
    </Tooltip>
  );
}

const MemoizedImageUploader = memo(ImageUploader);

export { MemoizedImageUploader as ImageUploader };
